module.exports = __webpack_public_path__ + "img/no-campaign.337c0b52.svg";